import React from 'react'
import { Link } from 'gatsby'
import { Flex, Box } from 'reflexbox'
import styled from 'styled-components'
// import { Back } from '../page/components'
import LogomarkHorizontal from '../svg/logomark-horizontal'
// import IconUser from '../svg/icon-user'
import GridMarks from './grid-marks'
import useWindowSize from '@rehooks/window-size'
// import SignOut from '../sign-out'
import SearchCta from '../page/search-cta'
import AppHeaderMobile from './app-header-mobile'

export default ({ title, backUrl, hideSearch, authUser }) => {
  const windowSize = useWindowSize()
  if (!windowSize) return null
  const { innerWidth } = windowSize

  if (innerWidth <= 900) {
    return <AppHeaderMobile backUrl={backUrl} authUser={authUser} />
  } else {
    return (
      <Header>
        <GridMarks />
        <Flex flexWrap="nowrap" width={['100%']}>
          <Box width={[1, 1 / 5]} display="flex" alignItems="center">
            <Link to="/">
              <LogomarkHorizontal />
            </Link>
          </Box>
          <Box width={[1, 2 / 5]} display="flex" alignItems="center">
            {title}
          </Box>
          <Box width={[1, 1 / 5]} display="flex" alignItems="center">
            {hideSearch === true ? null : <SearchCta backUrl={backUrl} />}
          </Box>
          {/* <Box
            width={[1, 1 / 5]}
            display="flex"
            justifyContent="space-between"
            alignItems="center"
          >
            <AccountLink>
              <Link to="/account" title="My Account">
                <UserIconWrap>
                  <IconUser />
                </UserIconWrap>
                Account
              </Link>
            </AccountLink>
            <SignOut />
          </Box> */}
        </Flex>
      </Header>
    )
  }
}

const Header = styled.div`
  height: 100px;
  background: ${props => props.theme.colors.greyDark};
  position: fixed;
  left: 0;
  top: 0;
  z-index: 500;
  width: 100%;
  padding-left: 60px;
  padding-right: 60px;
  display: flex;
  align-items: center;
  a {
    color: ${props => props.theme.colors.white};
    text-decoration: none;
  }
  @media screen and (max-width: ${props => props.theme.responsive.md}) {
    height: 76px;
    padding-left: 35px;
    padding-right: 35px;
  }
  @media screen and (max-width: ${props => props.theme.responsive.sm}) {
    padding-left: 14px;
    padding-right: 14px;
  }
`

// const AccountLink = styled.span`
//   a {
//     display: flex;
//     align-items: center;
//   }
// `
// const UserIconWrap = styled.span`
//   display: block;
//   width: 48px;
//   height: 48px;
//   border: 2px solid ${props => props.theme.colors.greyDark1};
//   border-radius: 48px;
//   margin-right: 10px;
//   display: flex;
//   justify-content: center;
//   align-items: center;
// `
